import {
	SET_NEW_REPORT_DRAWER_STATE,
	SET_NEW_REPORT_PROP_VALUE,
	REMOVE_NEW_REPORT_IMAGE,
	SET_NEW_REPORT_ADDRESS_ATTRIBUTE,
	SET_NEW_REPORT_LOCATION,
	RESET_NEW_REPORT_FORM,
	SERVER_SEND_NEW_REPORT,
	SHOW_NEW_REPORT_GET_ADDRESS_ERROR
} from 'constants/ActionTypes';

export const setNewReportDrawerState = payload => {
	return { type: SET_NEW_REPORT_DRAWER_STATE, payload };
};

export const setNewReportPropValue = payload => {
	return { type: SET_NEW_REPORT_PROP_VALUE, payload };
};

export const removeNewReportImage = index => {
	return { type: REMOVE_NEW_REPORT_IMAGE, payload: { index } };
};

export const setNewReportAddressAttribute = payload => {
	return { type: SET_NEW_REPORT_ADDRESS_ATTRIBUTE, payload };
};

export const setNewReportLocation = latlng => {
	return { type: SET_NEW_REPORT_LOCATION, payload: { latlng } };
};

export const resetNewReport = reportsDefaultInvisible => {
	return { type: RESET_NEW_REPORT_FORM, payload: { reportsDefaultInvisible } };
};

export const sendNewReport = (reportData, reportsDefaultInvisible) => {
	return { type: SERVER_SEND_NEW_REPORT, payload: { reportData, reportsDefaultInvisible } };
};

export const showNewReportGetAddressError = error => {
	return { type: SHOW_NEW_REPORT_GET_ADDRESS_ERROR, payload: { error } };
};



// WEBPACK FOOTER //
// ./actions/NewReport.js